
import { List, Card, Button, Tag, Row, Col, Typography, Space, Divider, Popconfirm, Empty, } from 'antd';
import { EnvironmentOutlined, DollarOutlined, TeamOutlined, CalendarOutlined, HomeOutlined, TagsOutlined  } from '@ant-design/icons';

const { Text, Paragraph } = Typography;


export default function ListarEmpleos({ loading, empleosFiltrados, postularEgresadoAEmpleo }) {
    return (
        <List
            grid={{ gutter: 24, xs: 1, sm: 1, md: 1, lg: 2, xl: 2, xxl: 2 }}
            dataSource={empleosFiltrados}
            pagination={{
                pageSize: 4,
            }}
            loading={loading}
            locale={{
                emptyText: (
                    <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description="Aún no hay ofertas laborales disponibles"
                    />
                ),
            }}
            renderItem={(empleo) => (
                <List.Item>
                    <Card
                        hoverable
                        styles={{
                            header: {
                                backgroundColor: "white",
                                color: "black"
                            },
                        }}
                        title={empleo?.titulo}
                    >

                        <Row gutter={[16, 16]}>
                            <Col span={24} >
                                <Space direction="vertical" size="middle" >

                                    <Space direction="vertical" size="small" >
                                        <Text>
                                            <HomeOutlined style={{ marginRight: '8px', color: '#3700fcff' }} />
                                            <strong>Empresa:</strong> {empleo?.empresa?.razon_social}
                                        </Text>
                                        <Text>
                                            <EnvironmentOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
                                            <strong>Ubicación:</strong> {empleo?.ubicacion}
                                        </Text>
                                        <Text>
                                            <TagsOutlined  style={{ marginRight: '8px', color: '#09e2f1ff' }} />
                                            <strong>Modalidad:</strong> {empleo?.tipo_empleo}
                                        </Text>
                                        <Text>
                                            <DollarOutlined style={{ marginRight: '8px', color: '#52c41a' }} />
                                            <strong>Salario:</strong> {empleo?.salario}
                                        </Text>
                                        <Text>
                                            <TeamOutlined style={{ marginRight: '8px', color: '#722ed1' }} />
                                            <strong>Vacantes disponibles:</strong> {empleo?.cantidad_personas}
                                        </Text>
                                        <Text>
                                            <CalendarOutlined style={{ marginRight: '8px', color: '#fa8c16' }} />
                                            <strong>Fecha límite:</strong> {empleo?.fecha_limite}
                                        </Text>
                                    </Space>

                                    <div>
                                        <Text strong>Habilidades requeridas:</Text>
                                        <div style={{ marginTop: '8px' }}>
                                            {empleo?.habilidades_requeridas.split(',').map((habilidad, index) => (
                                                <Tag key={index} style={{ marginBottom: '4px' }}>
                                                    {habilidad.trim()}
                                                </Tag>
                                            ))}
                                        </div>
                                    </div>

                                    <Paragraph type="secondary" style={{ marginBottom: 0 }}>
                                        {empleo?.descripcion}
                                    </Paragraph>
                                </Space>
                            </Col>
                        </Row>
                        <Row>
                            <Divider />
                            <Col span={24} >
                                <Popconfirm
                                    placement="topRight"
                                    title="¿Estas seguro de postularte a este empleo?"
                                    onConfirm={() => postularEgresadoAEmpleo(empleo)}
                                >
                                    <Button
                                        type="primary"
                                        size="large"
                                    >
                                        Postularse
                                    </Button>
                                </Popconfirm>
                            </Col>
                        </Row>
                    </Card>
                </List.Item>
            )}
        />
    )
}